import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect width=\"20\" height=\"20\" fill=\"url(#a)\" rx=\"10\"></rect><path fill=\"#fff\" d=\"M11.569 5.047q.095.062.136.172a.37.37 0 0 1 .008.227l-1.146 4.023h2.115q.095.001.175.056.079.057.117.151a.37.37 0 0 1-.06.372l-5.091 5.844a.299.299 0 0 1-.392.062.34.34 0 0 1-.137-.173.37.37 0 0 1-.007-.226l1.146-4.024H6.318a.3.3 0 0 1-.175-.056.34.34 0 0 1-.117-.151.37.37 0 0 1 .06-.372l5.091-5.844a.298.298 0 0 1 .391-.062zM6.25 2.5l.672 1.828L8.75 5l-1.828.672L6.25 7.5l-.672-1.828L3.75 5l1.828-.672zM13.125 13.75l.504 1.371 1.371.504-1.371.504-.504 1.371-.504-1.371-1.371-.504 1.371-.504z\"></path><defs><radialGradient id=\"a\" cx=\"0\" cy=\"0\" r=\"1\" gradientTransform=\"matrix(0 -20 18.1412 0 10 20)\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#AE35F7\"></stop><stop offset=\"1\" stop-color=\"#5F30D1\"></stop></radialGradient></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }